// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "media/styles/" + "vendors" + "." + "40a1cd27" + ".css"
}